// extracted by mini-css-extract-plugin
export default {"root":"PlasmicDeleteMilestone_root__vCjPu","rootfirstOne":"PlasmicDeleteMilestone_rootfirstOne__3cCO+"};